import * as SwitchPrimitive from '@radix-ui/react-switch';
import { FieldInputProps, FieldMetaProps } from 'formik';
import { FocusEvent } from 'react';
import tw from 'twin.macro';
import 'styled-components/macro';

const StyledSwitch = tw(SwitchPrimitive.Root)`
  w-5
  h-3
  px-half
  rounded-4xl
  relative

  bg-gray-30
  outline-none

  transition-all
  duration-fast

  focus-visible:(ring-4 ring-secondary-light)
  [&:not([data-disabled]):hover]:(ring-4 ring-secondary-lightest)
  [&[data-disabled]]:bg-gray-15
  [&[data-state="checked"]]:bg-secondary
  [&[data-state="checked"][data-disabled]]:bg-secondary-lighter
`;

const StyledThumb = tw(SwitchPrimitive.Thumb)`
  block
  w-2
  h-2
  rounded-full

  bg-white

  transition-transform
  duration-fast

  [&[data-state="checked"]]:translate-x-2
`;

export type SwitchProps = Omit<SwitchPrimitive.SwitchProps, 'value' | 'onChange' | 'onCheckedChange'> &
  Partial<Omit<FieldMetaProps<boolean>, 'value'>> &
  Partial<Omit<FieldInputProps<boolean>, 'value' | 'checked' | 'onChange'>> & {
    children?: React.ReactNode;
    value?: boolean;

    // Faking a ChangeEvent for formik compatibility
    onChange?(event: { target: { name: string; value: boolean } }): void;
  };

export const Switch = ({
  children,
  name = '',
  className,
  onChange,
  onBlur,
  checked,
  value,

  // Unused
  initialTouched,
  initialError,
  initialValue,
  error,
  touched,
  multiple,

  ...props
}: SwitchProps) => (
  <label tw="inline-flex flex-row items-center gap-1 text-sm/loose select-none" className={className}>
    <StyledSwitch
      name={name}
      checked={checked ?? value}
      onCheckedChange={value => onChange?.({ target: { name, value } })}
      onBlur={e => {
        (e as FocusEvent<HTMLInputElement>).target.name = name;
        onBlur?.(e);
      }}
      {...props}
    >
      <StyledThumb />
    </StyledSwitch>

    {children}
  </label>
);
